import jQuery from 'jquery';
import 'slick-carousel';
/* eslint-disable no-console */
const Testimonials = {
  onReady: () => {
    // eslint-disable-next-line no-unused-vars
    (function ($) {
      $('.site-content .testimonials__wrapper').slick({
        dots: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
      });
    })(jQuery);
  },
};

export default Testimonials;
